/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SEO from "../components/common/seo";
import { LoginContent } from "../components/container/login";
import { selectUserProfile } from "../store/auth/selector";
import { sanitizeUriString } from "../utils/sanitize";
import {
  cleanupStorage,
  getAuthToken,
  getLastVisitedPage,
  setLastVisitedPage,
} from "../utils/storage";

export function Login() {
  const navigate = useNavigate();
  const authToken = getAuthToken();
  const profile = useSelector(selectUserProfile);

  const [urlParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);

    const loginHintRaw = params.get("loginHint");
    const redirectUriRaw = params.get("redirectUri");

    const loginHint = loginHintRaw?.trim() ?? null;
    const redirectUri = sanitizeUriString(redirectUriRaw);

    return {
      loginHint,
      redirectUri,
    };
  });

  const cleanupAuthData = () => {
    const lastVisited = getLastVisitedPage();

    cleanupStorage();

    if (lastVisited) {
      setLastVisitedPage(lastVisited);
    }

    if (urlParams.redirectUri) {
      setLastVisitedPage(urlParams.redirectUri);
    }
  };

  useEffect(() => {
    if (urlParams.loginHint && authToken) {
      cleanupAuthData();
      setTimeout(() => {}, 1000);
    }

    if (urlParams.redirectUri) {
      setLastVisitedPage(urlParams.redirectUri);
    }

    if (!urlParams.loginHint) {
      const from = getLastVisitedPage() || "/";

      if (authToken && profile) {
        navigate(from, { replace: true });
      }

      if (authToken && !profile) {
        navigate("/logout");
      }
    }
  }, []);

  return (
    <>
      <SEO />
      <Container maxWidth={false} disableGutters>
        <LoginContent
          loginHint={urlParams.loginHint}
          redirectUri={urlParams.redirectUri}
          cleanupAuthData={cleanupAuthData}
        />
      </Container>
    </>
  );
}
